export default __webpack_public_path__ + "static/media/chevrons-down.043a13e7.svg";